// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"5fe3ddba","477":"e7360c9a","647":"c8218894","675":"04e2364d","696":"342f7a6e","781":"1cab74a8"}[chunkId] + ".chunk.js";
};